<script>
	import Multiselect from "vue-multiselect";
	export default{
		components: { Multiselect },
		data(){
			return{
				id: '',
				search: '',
				currentPage: 1,
				order: 'desc',
      			sortby: 'id',
      			limit: 0,
				limits: [
		        {value: 25, text: "25"},
		        {value: 50, text: "50"},
		        {value: 100, text: "100"},
		    	],
				response_error: []
			}
		},
		props: {
			isDisabled: {
				type: Boolean,
				default: () => false,
				},
			options: {
				type: Array,
				default: () => [
					{id: 1, name: 'text'},
					{id: 2, name: 'text2'}
				],
			}
		},
		mounted(){
			axios.get('/api/company/listings?page='+this.currentPage+'&limit='+this.limit+'&sortby='+this.sortby+'&order='+this.order+'&search='+this.search+'', {headers: {'Authorization' : 'Bearer '+this.$attrs.api_token}}).then(response => {
				this.options = response.data;
			}).catch(error => {
				this.response_error = error.data;
			});
			this.id = this.$attrs.id;
			
		},
		methods:{
			updateResource: function(selectedOption, id){
				this.$emit('listing-selected', selectedOption);
			},
			removeResource: function(selectedOption, id){
				this.$emit('listing-removed', selectedOption);
			},
			customLabel ({ title, desc }) {
		      return `${title} – ${desc}`
		    }
		}
	}
</script>
<template>
	<div>
	<multiselect v-model="id" track-by="name" label="name" :options="options" @select="updateResource" @remove="removeResource" :option-height="104" :disabled="isDisabled" >
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>-->
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100"><div class="avatar-sm mr-4 my-auto">
                        <span class="avatar-title rounded-circle">{{(option.name).slice(0,1)}}</span>
                      </div>
      <div class="option__desc d-flex flex-row w-75"><span class="option__title ml-2 my-auto w-100">{{ option.name }}<br><p class="m-0 lh-1 w-100 text-truncate"><small>{{ option.address_1 }}</small></p></span>
      </div>
  		</div></template>
    <template slot="option" slot-scope="{ option }">
    	<div class="d-flex"><div class="avatar-sm mr-4">
                        <span class="avatar-title rounded-circle">{{(option.name).slice(0,1)}}</span>
                      </div>
      <div class="option__desc d-flex flex-row w-50"><span class="option__title ml-2 my-auto w-100">{{ option.name }}<br><p class="m-0 lh-1 w-100 text-truncate"><small>{{ option.address_1 }}</small></p></span>
      </div>
  		</div>
    </template>
                  </multiselect>
   </div>
</template>